export default __webpack_public_path__ + "05ab6aed8e0c3219eb971a1971572278.png";